import loginService from '@/services/login.service';

import store from '..';

const state = {
  accessValid: false,
  electionId: '',
  election: '',
  electionName: '',
  expiresIn: '',
  hasVoted: '',
  identifier: '',
  userName: '',
  token: null,
  tokenExpiration: null,
  voterId: '',
  isAuthenticated: false,
  voterName: '',
  entityVoter: null,
  voterEmail: '',
  CreatePassword: false,
  entityPersonalData: null,
  enableRecaptcha: false,
  informPassword: false
};

const getters = {
  accessValid: state => {
    return state.accessValid;
  },
  isAuthenticated: state => {
    return state.isAuthenticated;
  },
  token: state => {
    return state.token;
  },
  name: state => {
    return state.name;
  },
  userId: state => {
    return state.voterId;
  }
};

const mutations = {
  updateAccessValid: (state, accessValid) => {
    state.accessValid = accessValid;
    window.localStorage.setItem('accessValid', state.accessValid);
  },
  initApp(state) {
    state.accessValid = window.localStorage.getItem('accessValid') === 'true';
    state.token = window.localStorage.getItem('token') || null;
    state.userName = window.localStorage.getItem('userName') || '';
    state.electionId = JSON.parse(
      window.localStorage.getItem('electionId') || null
    );

    state.tokenExpiration = parseInt(
      window.localStorage.getItem('tokenExpiration')
    );
    const currentTime = new Date().getTime();

    state.isAuthenticated =
      state.token !== null && state.tokenExpiration - currentTime > 0;
  },
  updateUserName(state, userName) {
    state.userName = userName;
  },

  login(state, params) {
    state.user = params.user;
    state.identifier = params.token.entityVoter.identifier;
    state.election = params.token.entityVoter.election_id;
    state.hasVoted = params.token.entityVoter.has_voted;
    state.entityVoter = params.token.entityVoter;
    if (!params.token.CreatePassword) {
      state.token = params.token.token;
      state.accessValid = params.token.accessValid;
      state.isAuthenticated = true;
      // persist user info into local store
      window.localStorage.setItem('accessValid', state.accessValid);
      window.localStorage.setItem('token', state.token);
      window.localStorage.setItem('userName', state.userName);
      const tokenExpiration = new Date();
      tokenExpiration.setSeconds(
        tokenExpiration.getSeconds() + parseInt(params.token.expires_in)
      );
      window.localStorage.setItem('tokenExpiration', tokenExpiration.getTime());
    } else {
      state.CreatePassword = true;
    }
    store.dispatch('voter/loadVoter', { voterJson: params.token.entityVoter });
  },
  logout(state) {
    state.token = null;
    state.userName = '';
    state.isAuthenticated = false;
    state.accessValid = false;
    state.voterId = 0;
    store.dispatch('election/clearElection', 0);
    localStorage.clear();
  },
  identifierLogin(state, payload) {
    state.voterId = payload.id;
    state.userName = payload.name;
    state.voterName = payload.name;
    state.electionId = payload.election_id;
    state.voterEmail = payload.email;
    state.existPassword = payload.existPassword;
    state.entityPersonalData = payload.jsonPersonalData;
    state.enableRecaptcha = payload.enableRecaptcha;
    state.informPassword = payload.informPassword;
  },
  alterPassword(state, payload) {
    state.token = payload.token;
    state.election = payload.election_id;
    state.accessValid = payload.accessValid;
    state.identifier = payload.identifier;
    state.isAuthenticated = true;
    // persist user info into local store
    window.localStorage.setItem('accessValid', state.accessValid);
    window.localStorage.setItem('token', state.token);
    window.localStorage.setItem('userName', state.userName);
    const tokenExpiration = new Date();
    tokenExpiration.setSeconds(
      tokenExpiration.getSeconds() + parseInt(payload.expires_in)
    );
    window.localStorage.setItem('tokenExpiration', tokenExpiration.getTime());
    state.CreatePassword = false;
  }
};
const actions = {
  initApp({ commit }) {
    commit('initApp');
  },
  login({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      loginService
        .login(credentials)
        .then(response => {
          if (
            response &&
            response.status &&
            response.status.toLowerCase() === 'ok'
          ) {
            commit('login', { token: response.data, user: credentials.id });
            resolve();
          } else {
            reject('Dados de login incorretos.');
          }
        })
        .catch(error => reject(error));
    });
  },
  loginMSAL({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      loginService
        .loginMSAL(credentials)
        .then(response => {
          if (
            response &&
            response.status &&
            response.status.toLowerCase() === 'ok'
          ) {
            commit('login', { token: response.data, user: credentials.id });
            resolve();
          } else {
            reject('Dados de login incorretos.');
          }
        })
        .catch(error => reject(error));
    });
  },
  identifierLogin({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      loginService
        .identifierLogin({
          login: credentials.user,
          recaptcha: credentials.recaptcha,
          election_id: credentials.election_id,
          typeIdentifier: credentials.typeIdentifier === undefined ? '' : credentials.typeIdentifier
        })
        .then(response => {
          if (response && response.status && response.status.toLowerCase() === 'ok') {
            commit('identifierLogin', response.data);
            resolve();
          } else {
            reject('Dados incorretos. Por favor, verifique.');
          }
        })
        .catch(error => reject(error));
    });
  },
  alterPassword({ commit }, params) {
    return new Promise((resolve, reject) => {
      loginService
        .alterPassword(params)
        .then(response => {
          if (response && response.status && response.status.toLowerCase() === 'ok') {
            commit('alterPassword', response.data);
            resolve();
          } else {
            reject('Alteração não realizada.');
          }
        })
        .catch(error => reject(error));
    });
  },
  loadIdentifier: async ({ commit }, { voterJson }) => {
    commit('identifierLogin', voterJson);
  },
  logout({ commit }) {
    commit('logout');
  }
};

const userStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default userStore;
